// extracted by mini-css-extract-plugin
module.exports = {"requestBox":"style_request-box__hA_zr","mainAdornment":"style_main-adornment__Gu2xw","imageAdornment":"style_image-adornment__rLVCI"};